import React, {useEffect, useState} from 'react';

import {SiteRouter} from './SiteRouter';

import {TopBar} from './components/topbar/Topbar';
import {SideBar} from './components/sidebar/SideBar';

import {useWindowSize} from './hooks/useWindowSize.js';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

const widthLimit = 768;

const App = () => {
  const {width} = useWindowSize();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const isCurrentlyOpen = width > widthLimit;
    setIsOpen(isCurrentlyOpen);
  }, [width]);

  const toggle = () => {
    setIsOpen(prevState => !prevState);
  };

  return (
    <div className='app'>
      {/*<TopBar toggle={toggle} />

      <div className='d-flex'>
        <SideBar toggle={toggle} isOpen={isOpen} />*/}
        <SiteRouter />
      {/*</div>*/}
      {/*
        <footer className="py-8 py-md-11 bg-black">
          <div className="container">
            <div className="row">
            </div>
          </div>
        </footer>
      */}
    </div>
  );
}

export default App;
